import { render, staticRenderFns } from "./pi-rate-charge-card.vue?vue&type=template&id=8eecd5d6&scoped=true&"
import script from "./pi-rate-charge-card.vue?vue&type=script&lang=ts&"
export * from "./pi-rate-charge-card.vue?vue&type=script&lang=ts&"
import style0 from "./pi-rate-charge-card.vue?vue&type=style&index=0&id=8eecd5d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eecd5d6",
  null
  
)

export default component.exports